import { ProductSerializedBase } from '@app/baseBtl/catalog/products/interface/configurable';

import { SubscriptionBase } from '../subscription';

export class OptionBase extends SubscriptionBase {
    public serialize(): ProductSerializedBase {
        return {
            uniqueId: this.uniqueId,
            gencode: this.gencode,
            price: this.price,
            quoteItem: {
                attributes: false,
                options: true,
                product: this.id,
                qty: 1,
                redirectPending: false,
                selectedPayment: 1,
            },
        };
    }
}
